import { resolveInstalledNodeScriptLaunchCandidates, resolveInstalledNodeScriptLaunchContract, verifyCliLaunchContract, } from "@wakeloop/adapter-core";
const DEFAULT_CODEX_COMMAND = "codex";
export async function resolveInstalledCodexLaunchCandidates() {
    const installedCandidates = await resolveInstalledNodeScriptLaunchCandidates({
        commandName: DEFAULT_CODEX_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_CODEX_BIN),
        displayName: "Codex",
    });
    if (!installedCandidates.ok) {
        return installedCandidates;
    }
    const candidates = (await Promise.all(installedCandidates.candidates.map(async (candidate) => {
        const verification = await verifyCodexLaunchContract({
            launchContract: candidate.launchContract,
        });
        return verification.ok ? candidate : null;
    }))).filter((candidate) => {
        return candidate !== null;
    });
    if (candidates.length === 0) {
        return {
            errorMessage: "Codex is installed, but WakeLoop can't start it on this device.",
            ok: false,
        };
    }
    return {
        candidates,
        ok: true,
    };
}
export async function resolveInstalledCodexLaunchContract() {
    return await resolveInstalledNodeScriptLaunchContract({
        commandName: DEFAULT_CODEX_COMMAND,
        configuredCommand: normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_CODEX_BIN),
        displayName: "Codex",
    });
}
export async function verifyCodexLaunchContract(input) {
    return await verifyCliLaunchContract({
        cwd: input.cwd ?? process.cwd(),
        displayName: "Codex",
        launchContract: input.launchContract,
        probeArgs: ["--version"],
        timeoutMs: resolveCodexTimeoutMs(),
    });
}
export function resolveCodexTimeoutMs() {
    // Explicit watchdog override only. Normal WakeLoop Wake execution has no fixed
    // Codex process timeout.
    const raw = normalizeOptionalText(process.env.WAKELOOP_DAEMON_RUNTIME_REQUEST_TIMEOUT_MS);
    if (!raw) {
        return null;
    }
    const parsed = Number.parseInt(raw, 10);
    if (!Number.isFinite(parsed) || parsed <= 0) {
        return null;
    }
    return parsed;
}
function normalizeOptionalText(value) {
    const normalized = String(value ?? "").trim();
    return normalized.length > 0 ? normalized : null;
}
